(function () {
  'use strict';

  function applyMotionPreference(root) {
    var scope = root || document;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var videos = scope.querySelectorAll('[data-festive-video]');
    videos.forEach(function (video) {
      var poster = video.parentElement.querySelector('[data-festive-poster]');
      if (reduce) {
        video.pause();
        video.hidden = true;
        if (poster) poster.hidden = false;
      } else {
        video.hidden = false;
        if (poster) poster.hidden = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () { /* autoplay blocked — poster stays as the visual fallback via the video's own poster attribute */ });
        }
      }
    });

    var forceOff = scope.querySelectorAll('[data-festive-force-off]');
    forceOff.forEach(function (el) {
      el.hidden = reduce;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyMotionPreference(document);
  });

  /* Theme editor re-renders a section without firing DOMContentLoaded, so any
     [data-festive-video] inside it stays `hidden` and never plays — which reads
     as "autoplay is broken" in the editor while working fine on the storefront. */
  document.addEventListener('shopify:section:load', function (e) {
    applyMotionPreference(e.target);
  });

  window.SindhiFestiveMotion = { apply: applyMotionPreference };
}());
